import { post as postProduct } from 'redux/products/actions';
import { createResourceActions } from 'utils/actionsGenerator';

import {
    EDIT_IN_PRODUCT,
    FETCH_SINGLE_PRODUCT,
    FETCH_SINGLE_PRODUCT_SUCCESS,
    FETCH_SINGLE_PRODUCT_FAIL,
    PATCH_PRODUCT,
    PATCH_PRODUCT_FAIL,
    PATCH_PRODUCT_SUCCESS,
    RESET_PRODUCT,
    TOGGLE_CREATE_PRODUCT_DIALOG,
    types,
} from './reducer';

const embeds = [
    'campaigns.multiUsePromotion',
    'campaigns.singleUsePromotions',
    'campaigns.page',
    'keywords',
    'listings',
    'media',
    'primaryImage',
    'reviews',
].join(',');

export const { fetch, put } = createResourceActions({
    name: 'product',
    params: { embeds: 'categories,keywords,media' },
    types,
    url: '/products',
});

export const fetchProduct = (id) => {
    return {
        payload: {
            request: {
                method: 'get',
                params: { embeds },
                url: `/products/${id}`,
            },
        },
        types: [FETCH_SINGLE_PRODUCT, FETCH_SINGLE_PRODUCT_SUCCESS, FETCH_SINGLE_PRODUCT_FAIL],
    };
};

export const patch = (id, data) => {
    return {
        payload: {
            request: {
                data,
                method: 'patch',
                params: { embeds },
                url: `/products/${id}`,
            },
        },
        types: [PATCH_PRODUCT, PATCH_PRODUCT_SUCCESS, PATCH_PRODUCT_FAIL],
    };
};

export const saveProduct = (product) => {
    const action = product.get('id') ? put : postProduct;

    return action(product);
};

export const editInProduct = (path) => (value) => ({
    path,
    type: EDIT_IN_PRODUCT,
    value
});

export const editProduct = (field, value) => editInProduct(['data', field])(value);

export const toggleCreateProductDialog = () => ({ type: TOGGLE_CREATE_PRODUCT_DIALOG });

export const resetProduct = () => ({ type: RESET_PRODUCT });

export const postKeyword = (data) => ({
    payload: {
        request: {
            data,
            method: 'post',
            url: '/keywords',
        },
    },
    types: ['POST_KEYWORD', 'POST_KEYWORD_SUCCESS', 'POST_KEYWORD_FAIL'],
});
